module.exports = [
	{
		"Sl_No": "01",
		"file": "VIP",
		"type": "VIP Suite (Patient Room)",
		"price": "30,000.00"
	},
	{
		"Sl_No": "02",
		"file": "STANDARD",
		"type": "Standard Suite",
		"price": "20,000.00"
	},
	{
		"Sl_No": "03",
		"file": "DELUXE",
		"type": "Deluxe Single",
		"price": "13,000.00"
	},
	{
		"Sl_No": "04",
		"file": "Luxary",
		"type": "Luxary Single",
		"price": "11,500.00"
	},
	{
		"Sl_No": "05",
		"file": "STANDARD_single",
		"type": "Standard Single",
		"price": "10,000.00"
	},
	{
		"Sl_No": "06",
		"file": "DOUBLE",
		"type": "Double Bedded Room",
		"price": "5,500.00"
	},
	{
		"Sl_No": "07",
		"file": "triple",
		"type": "Triple Bedded Room",
		"price": "4,000.00"
	},
	{
		"Sl_No": "08",
		"file": "ONCOLOGY",
		"type": "Oncology Ward",
		"price": "3,500.00"
	},
	{
		"Sl_No": "09",
		"file": "GENERAL",
		"type": "General Ward",
		"price": "4,200.00"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/rooms.json
// module id = 865
// module chunks = 0